import { Component } from "react"
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from "../../../actions/fillCombo_action";
import { exhibitorTypeActionId, toastError, paymentTypeActionId } from "../../../utils/constants";
import { getExhibitorManualFormSummaryList_action, getExhibitorManualFormSummaryExport_action } from "../../../actions/admin_module_action/exhibitor_manualForm_summary_action/exhibitor_manualForm_summary_action";
import { data } from "jquery";
import Pagination from "../../../utils/pagination";
import Workbook from 'react-excel-workbook'
import Modal from "react-modal";
import FasciaForm from "../../exhibitor_module/manual_forms/forms/fascia_Form/fascia_form";
import ExhibitorBadge from "../../exhibitor_module/manual_forms/forms/exhibitor_badge_form/exhibitor_badge";
import ExhibitorDetails from "../../exhibitor_module/manual_forms/forms/exhibitor_details_form/exhibitor_details";
import VisaApplication from "../../exhibitor_module/manual_forms/forms/invitationVisaApplication/invitationVisaApplicationList";
import EDirectoryList from "../../exhibitor_module/manual_forms/forms/e-direcory_form/e-directory_list";
import KeywordsInformation from "../../exhibitor_module/manual_forms/forms/keywords_information_form/keywords_information";
import StallDesign from "../../exhibitor_module/manual_forms/forms/stallDesign/stallDesign";
import AdditionalFurniture from "../../exhibitor_module/manual_forms/forms/additional furniture/additional_furniture";
import StallPossession from "../../exhibitor_module/manual_forms/forms/stall_possesion/stall_possesion";
import PowerConnection from "../../exhibitor_module/manual_forms/forms/power_connection_form/power_connection";
import FreightForward from "../../exhibitor_module/manual_forms/forms/freight_forward/freight_forward";
import Water from "../../exhibitor_module/manual_forms/forms/water_form/water";
import AirConnectionApplication from "../../exhibitor_module/manual_forms/forms/airConnectionApplication/airConnectionApplication";
import CarPassesApplication from "../../exhibitor_module/manual_forms/forms/car_passes_application/car_passes_application";
import LiquareLicense from "../../exhibitor_module/manual_forms/forms/liquare_license/liquare_license";
import LeadRetrievalConnectionApplication from "../../exhibitor_module/manual_forms/forms/leadRetrievalConnectionApplication/leadRetrievalConnectionApplication";
import MeetingRoomRequestForm from "../../exhibitor_module/manual_forms/forms/Meeting room request form/MeetingRoomRequestForm";
import DelegateMeeting from "../../exhibitor_module/manual_forms/forms/delegate_meeting/delegate_meeting";
import VisitorMeetingApplication from "../../exhibitor_module/manual_forms/forms/visitor_meeting_application/visitor_meeting_application";
import InternetConnection from "../../exhibitor_module/manual_forms/forms/internet_connection/internet_connection";
import HousekeepingConnection from "../../exhibitor_module/manual_forms/forms/housekeeping_connection/housekeeping_connection";
import SecurityApplication from "../../exhibitor_module/manual_forms/forms/security_application/security_application";
import CateringServices from "../../exhibitor_module/manual_forms/forms/catering_services/catering_services";
import HostHostessRequirements from "../../exhibitor_module/manual_forms/forms/host_hostess_requirement/host_hostess_requirement";
import BrandingOpportunityAndAdvertisement from "../../exhibitor_module/manual_forms/forms/brandingApportunityAndAdvertisement/brandingApportunityAndAdvertisement";
import RentalAudioAndVideoEquipment from "../../exhibitor_module/manual_forms/forms/rentalAudioAndVedioEquipment/rentalAudioAndVedioEquipment";
import ExhibitorContractorBadgeApplication from "../../exhibitor_module/manual_forms/forms/exhibitor_contractor_badgeApplication/exhibitor_contractor_badgeApplication";
import PlantAndBeautification from "../../exhibitor_module/manual_forms/forms/PlantAndBeautification/PlantAndBeautification";
import RentalAudioAndVedioEquipment from "../../exhibitor_module/manual_forms/forms/rentalAudioAndVedioEquipment/rentalAudioAndVedioEquipment";


class ManualFormSummary extends Component {
    // intialize constructor
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            exhibitor: "",
            exhibitorTypeId: "",
            exhibitorTypeList: [],
            exhibitorList: [],
            currentPage: 1,
            headerData: [],
            rowData: [],
            exhibitorExportData: [],
            loginAccesslist: [],
            paymentTypeId: "",
            paymentTypeList: [],
            isManualFormModalOpen: false,
            selectedServiceName: null,
        }
        this.getFillList = this.getFillList.bind(this)
        this.getExhibitorManualFormSummary = this.getExhibitorManualFormSummary.bind(this)
        this.onSearchClick = this.onSearchClick.bind(this)
        this.clearValue = this.clearValue.bind(this)
        this.onCreateExcel = this.onCreateExcel.bind(this)
        this.updateItem = this.updateItem.bind(this)
        this.createTableData = this.createTableData.bind(this)
        this.getExhibitorManualFormSummaryExport = this.getExhibitorManualFormSummaryExport.bind(this)
        this.onCreateExcel2 = this.onCreateExcel2.bind(this)
        this.getDownloadAccess = this.getDownloadAccess.bind(this)
    }

    componentDidMount() {
        this.setState({ loginAccesslist: JSON.parse(sessionStorage.getItem('loginDataSS'))['loginAccesslist'] })
        this.getFillList(exhibitorTypeActionId, '', '', '', '', '');
        this.getFillList(paymentTypeActionId, '', '', '', '', '');
        this.getExhibitorManualFormSummary()
        this.getExhibitorManualFormSummaryExport()
    }

    // Get Fill Lists
    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
            .then((data) => {
                if (data.error != 1) {
                    // Exhibitor Type list
                    if (actionID === exhibitorTypeActionId) {
                        console.log("Exhibitor Type list data", data.data)
                        this.setState({
                            exhibitorTypeList: data.data.length > 0 ? data.data : [],
                            isLoading: false
                        })
                    }
                }
                if (actionID === paymentTypeActionId) {
                    console.log("Payment Type list data", data.data)
                    this.setState({
                        paymentTypeList: data.data.length > 0 ? data.data : [],
                        isLoading: false
                    })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    // For Exhibitor List with Manual Form Summary
    getExhibitorManualFormSummary() {
        const { exhibitor, exhibitorTypeId, paymentTypeId } = this.state
        this.setState({ isLoading: true })
        this.props.getExhibitorManualFormSummaryList_action(exhibitor,
            exhibitorTypeId != "" && exhibitorTypeId != "Select Exhibitor Type" ? exhibitorTypeId : "", paymentTypeId)
            .then((data) => {
                if (data.error != 1) {
                    console.log("getExhibitorManualFormSummary Data", data.data)
                    this.setState({
                        exhibitorList: data.data,
                        isLoading: false
                    })
                    this.createTableData(data.data)
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    // For Exhibitor Export Data with Manual Form Summary
    getExhibitorManualFormSummaryExport() {
        const { exhibitor, exhibitorTypeId } = this.state
        this.setState({ isLoading: true })
        this.props.getExhibitorManualFormSummaryExport_action()
            .then((data) => {
                if (data.error != 1) {
                    console.log("getExhibitorManualFormSummaryExport Data", data.data)
                    this.setState({
                        exhibitorExportData: data.data,
                        isLoading: false
                    })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    // On Search Click
    onSearchClick() {
        this.getExhibitorManualFormSummary()
    }

    // On Clear Click
    clearValue() {
        this.setState({
            exhibitor: "",
            exhibitorTypeId: "",
            paymentTypeId: '',
        })
        setTimeout(() => {
            this.getExhibitorManualFormSummary()
        }, 500);
    }

    // to create excel file
    onCreateExcel() {
        const { exhibitorList } = this.state
        console.log("xxxxxxxxxxxxxxxxx", exhibitorList)
        var listData = []
        exhibitorList.length > 0 && exhibitorList.map((item, index) => {
            var mapData1 = {
                'SR No': index + 1,

            }
            var finalMapData = { ...mapData1, ...item }
            listData.push(finalMapData)
        })
        console.log('listData', listData);

        var excludeKeys = [
            'ExhRegistrationID', 'ExhibitionID',
        ]

        // Function to remove keys from objects
        function removeKeysFromObjects(arr, keys) {
            return arr.map((obj) => {
                const newObj = { ...obj }; // Create a new object to avoid modifying the original
                keys.forEach((key) => delete newObj[key]); // Remove specified keys from the new object
                return newObj;
            });
        }

        // Remove keys from the array of objects
        const newArray = removeKeysFromObjects(listData, excludeKeys);
        console.log("new arrya-->", newArray);


        var columnArray = [],
            rowData = [];
        // for column data 
        newArray.map((data, index) => {
            if (index == 0) {
                Object.keys(data).map((key, index) => {
                    columnArray.push(key)
                })
            }
        })


        // for row data
        newArray.map((data, index) => {
            rowData.push(data)
        })

        // console.log("rowData", rowData)
        // this.setState({
        //     columnArrayData: columnArray,
        //     rowData: rowData
        // })

        // { this.renderList() }

        return (
            <div>
                {exhibitorList.length > 0 ? <Workbook filename="ManualForm_Summary.xlsx" style={{}} element={
                    <button type="button" className="btn btn-aqua m-0"
                        disabled={!this.getDownloadAccess()}
                    >
                        Excel
                    </button>
                }>
                    <Workbook.Sheet data={rowData} name="Sheet A">
                        {columnArray.map((value, index) =>
                            <Workbook.Column label={value} value={value} />
                        )
                        }
                    </Workbook.Sheet>
                </Workbook> : <button type="button" className="btn btn-aqua m-0" disabled={true}>
                    Excel
                </button>}
            </div>
        );
    }

    // to create excel Export Data
    onCreateExcel2() {
        const { exhibitorExportData } = this.state
        var listData = []
        exhibitorExportData.length > 0 && exhibitorExportData.map((item, index) => {
            var mapData1 = {
                'SR No': index + 1,

            }
            var finalMapData = { ...mapData1, ...item }
            listData.push(finalMapData)
        })
        console.log('listData', listData);

        var columnArray = [],
            rowData = [];
        // for column data 
        listData.map((data, index) => {
            if (index == 0) {
                Object.keys(data).map((key, index) => {
                    columnArray.push(key)
                })
            }
        })


        // for row data
        listData.map((data, index) => {
            rowData.push(data)
        })

        // console.log("rowData", rowData)
        // this.setState({
        //     columnArrayData: columnArray,
        //     rowData: rowData
        // })

        // { this.renderList() }

        return (
            <div>
                {exhibitorExportData.length > 0 ? <Workbook filename="ManualForm_Summary_ExportData.xlsx" style={{}} element={
                    <button type="button" className="btn btn-aqua"
                        disabled={!this.getDownloadAccess()}
                    >
                        Export Data
                    </button>
                }>
                    <Workbook.Sheet data={rowData} name="Sheet A">
                        {columnArray.map((value, index) =>
                            <Workbook.Column label={value} value={value} />
                        )
                        }
                    </Workbook.Sheet>
                </Workbook> : <button type="button" className="btn btn-aqua" disabled={true}>
                    Export Data
                </button>}
            </div>
        );
    }

    // Update Current Page
    updateItem(item) {
        const { exhibitorList } = this.state
        this.setState({ currentPage: item });
        const recordsPerPage = 10;
        const indexOfLastRecord = item * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = exhibitorList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(exhibitorList.length / recordsPerPage)
    }

    // Create table data dyanamic
    createTableData(list) {
        var listData = []
        var mapData
        list.length > 0 && list.map((item, index) => {
            var mapData1 = {
                'SR No': index + 1,

            }
            var finalMapData = { ...mapData1, ...item }
            listData.push(finalMapData)
        })
        console.log('listData', listData);

        var excludeKeys = [
            'Address_Line_1', 'Address_Line_2', 'AlternateMobileNo', 'BankName', 'Bank_AccountName', 'Bank_AccountNo', 'Bank_AccountType',
            'Bank_Branch', 'City', 'CompanyRegistrationNo', 'Country', 'Designation', 'ExhibitionID', 'FasciaName', 'GSTNo',
            'IECCode', 'InvAddress_Line_1', 'InvAddress_Line_2', 'InvAlternateMobileNo', 'InvCity', 'InvCompanyName', 'InvCountry', 'InvDesignation',
            'InvMobileNo', 'InvPersonFirstName', 'InvPersonLastName', 'InvPincode', 'InvPrimaryEmail', 'InvSecondaryEmail', 'InvState',
            'InvTeleFax', 'InvTelephone', 'InvTelephone1', 'InvWebsite', 'MobileNo', 'MobileNo', 'NameOnPANCard', 'OpenSides',
            'Owner_Email', 'Owner_FirstName', 'Owner_Mobile', "Owner_LastName", 'PANNo', 'PersonIncharge_FirstName', 'PersonIncharge_LastName',
            'Pincode', 'PrimaryEmail', 'SameAsCorrespondence', 'SecondaryEmail', 'StallArea', 'StallType', 'State', 'SwiftCode_IFSCCode', 'TANNo',
            'TeleFax', 'Telephone', 'Telephone1', 'Website', 'exhRegistrationNo', 'AgentName'
        ]

        // Function to remove keys from objects
        function removeKeysFromObjects(arr, keys) {
            return arr.map((obj) => {
                const newObj = { ...obj }; // Create a new object to avoid modifying the original
                keys.forEach((key) => delete newObj[key]); // Remove specified keys from the new object
                return newObj;
            });
        }

        // Remove keys from the array of objects
        const newArray = removeKeysFromObjects(listData, excludeKeys);
        console.log("new arrya-->", newArray);

        var columnMapping = {
            "POWER CONNECTION": "Power Connection",
            "FREIGHT FORWARD": "Freight Forward",
            "WATER CONNECTION": "Water Connection",
            "AIR COMPRESSED": "Air Connection",
            "CAR PASSES APPLICATION": "Car Passes Application",
            "LIQUOR LICENSE": "Liquor License",
            "LEAD RETRIEVAL CONNECTION APPLICATION": "Lead Retrieval Connection Application",
            "MEETING ROOM REQUEST FORM": "Meeting Room Request Form",
            "DELEGATE MEETING": "Delegate Meeting",
            "VISITOR MEETING APPLICATION": "Visitor Meeting Application",
            "INTERNET CONNECTION": "Internet Connection",
            "HOUSEKEEPING CONNECTION APPLICATION": "Housekeeping Connection",
            "SECURITY APPLICATION": "Security Application",
            "CATERING SERVICES": "Catering Services",
            "HOST AND HOSTESS": "Host & Hostess",
            "BRANDING OPPORTUNITY & ADVERTISING FORM": "Branding & Advertisement",
            "RENTAL AUDIO & VIDEO EQUIPMENT FORM": "Rental Audio & Video",
            "EXHIBITOR CONTRACTOR BADGE APPLICATION": "Exhibitor Contractor Badge"
        };

        var columnArray = []
        var rowData = []
        newArray.map((data, i) => {
            Object.keys(data).map((key, index) => {
                if (i == 0) {
                    columnArray.push(columnMapping[key] || key)
                }
            })
        })
        console.log("111111111111111111111111111111", columnArray)
        // for row data
        newArray.map((data, index) => {
            rowData.push(Object.values(data))
        })
        console.log("2222222222222222222222", rowData)
        this.setState({
            headerData: columnArray,
            rowData: rowData
        })
    }

    getDownloadAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '11');
        if (moduleAccess) {
            return moduleAccess.DownloadAccess;
        } else {
            return false
        }
        return false;
    }

    openModal(ServiceName) {
        if (ServiceName === "Fascia") {
            return <FasciaForm />;
        } else if ((ServiceName || "").trim() === "Exhibitor Badge") {
            return <ExhibitorBadge />;
        } else if ((ServiceName || "").trim() === "Exhibit Details") {
            return <ExhibitorDetails />;
        } else if ((ServiceName || "").trim() === "Visa Application") {
            return <VisaApplication />;
        } else if ((ServiceName || "").trim() === "E-Directory") {
            return <EDirectoryList />;
        } else if ((ServiceName || "").trim() === "Keyword Manual Form") {
            return <KeywordsInformation />;
        } else if ((ServiceName || "").trim() === "Stall Design") {
            return <StallDesign />;
        } else if ((ServiceName || "").trim() === "Furniture") {
            return <AdditionalFurniture />;
        } else if ((ServiceName || "").trim() === "Stall Possession") {
            return <StallPossession />;
        } else if ((ServiceName || "").trim() === "Power Connection") {
            return <PowerConnection />;
        } else if ((ServiceName || "").trim() === "Freight Forward") {
            return <FreightForward />;
        } else if ((ServiceName || "").trim() === "Water Connection") {
            return <Water />;
        } else if ((ServiceName || "").trim() === "Air Connection") {
            return <AirConnectionApplication />;
        } else if ((ServiceName || "").trim() === "Car Passes Application") {
            return <CarPassesApplication />;
        } else if ((ServiceName || "").trim() === "Liquor License" || ServiceName === "LIQUOR LICENSE") {
            return <LiquareLicense />;
        } else if ((ServiceName || "").trim() === "Lead Retrieval Connection Application") {
            return <LeadRetrievalConnectionApplication />;
        } else if ((ServiceName || "").trim() === "Meeting Room Request Form") {
            return <MeetingRoomRequestForm isFromSummary={true} />;
        } else if ((ServiceName || "").trim() === "Delegate Meeting") {
            return <DelegateMeeting />;
        } else if ((ServiceName || "").trim() === "Visitor Meeting Application") {
            return <VisitorMeetingApplication />;
        } else if ((ServiceName || "").trim() === "Internet Connection") {
            return <InternetConnection isFromSummary={true} />;
        } else if ((ServiceName || "").trim() === "Housekeeping Connection") {
            return <HousekeepingConnection isFromSummary={true} />;
        } else if ((ServiceName || "").trim() === "Security Application") {
            return <SecurityApplication isFromSummary={true} />;
        } else if ((ServiceName || "").trim() === "Catering Services") {
            return <CateringServices />;
        } else if ((ServiceName || "").trim() === "Host & Hostess") {
            return <HostHostessRequirements />;
        } else if ((ServiceName || "").trim() === "Branding & Advertisement") {
            return <BrandingOpportunityAndAdvertisement />;
        } else if ((ServiceName || "").trim() === "Rental Audio & Video") {
            return <RentalAudioAndVideoEquipment />;
        } else if ((ServiceName || "").trim() === "Exhibitor Contractor Badge") {
            return <ExhibitorContractorBadgeApplication />;
        } else if ((ServiceName || "").trim() === "plantAndBeautification") {
            return <PlantAndBeautification />;
        } else {
            return null; // or <NotFound />
        }
    }

    handleManualFormModal = (serviceName, ExhRegistrationID) => {
        console.log("serviceName", serviceName)
        console.log("ExhRegistrationID", ExhRegistrationID)
        sessionStorage.setItem("ExhRegistrationIDSS", ExhRegistrationID);
        this.setState({
            isManualFormModalOpen: true,
            selectedServiceName: serviceName,
        });
    };

    render() {
        const { isLoading, currentPage, exhibitor, paymentTypeList, paymentTypeId, exhibitorTypeId, exhibitorTypeList, exhibitorList, headerData, rowData } = this.state
        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = rowData.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(rowData.length / recordsPerPage)

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                <div className={JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ? "with-dr-container" : "with-dr-container com-height"}>
                    <div className="main-container">
                        <AdminDrawer />
                        <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                                <h6 className="text-white mb-0 p-2">Exhibitor Summary</h6>
                            </div>
                        </div>
                    </div>
                    <div className="admin-top-space p-2 pb-0">
                        <div className="row m-0 align-items-end g-2">
                            <div className="col-xl-3 mb-3">
                                <label>Exhibitor Company Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    defaultValue=""
                                    required=""
                                    value={exhibitor}
                                    onChange={(e) => this.setState({ exhibitor: e.target.value })}
                                />
                            </div>
                            <div className="col-xl-3 mb-3">
                                <label htmlFor="validationCustom03">Exhibitor Type</label>
                                <select className="form-control"
                                    value={exhibitorTypeId}
                                    onChange={(e) => this.setState({ exhibitorTypeId: e.target.value })}
                                >
                                    <option>Select Exhibitor Type</option>
                                    {
                                        exhibitorTypeList.length > 0 && exhibitorTypeList.map((data) => (
                                            <option key={data.ID} value={data.ID}>{data.ExhibitorType}</option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div className="col-xl-3 mb-3">
                                <label htmlFor="validationCustom03">Payment Type</label>
                                <select className="form-control"
                                    value={paymentTypeId}
                                    onChange={(e) => this.setState({ paymentTypeId: e.target.value })}
                                >
                                    <option>Select Payment Type</option>
                                    {
                                        paymentTypeList.length > 0 && paymentTypeList.map((data) => (
                                            <option key={data.ID} value={data.ID}>{data.PaymentType}</option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div className="col-xl-3 mb-3 d-flex gap-1">
                                <button type="button" className="btn btn-aqua mt-4"
                                    onClick={e => this.onSearchClick()}
                                >
                                    Search
                                </button>
                                <button type="button" className="btn btn-gray py-1 mt-4"
                                    onClick={e => this.clearValue()}
                                >
                                    Clear
                                </button>
                            </div>
                        </div>
                        <div className="row m-0">
                            <div className="col-12 mb-1 d-flex justify-content-end gap-2 px-0">
                                {this.onCreateExcel()}
                                {this.onCreateExcel2()}
                            </div>
                        </div>
                    </div>
                    <div className="row m-0 mx-1 px-2">
                        <div class="table-responsive px-0 sticky-table-wrapper service-list-grid">
                            <table class="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0">
                                <thead class="table-light">
                                    <tr>
                                        {
                                            headerData.length > 0 && headerData.map((data, index) => (
                                                data != 'ExhRegistrationID' &&
                                                <th className="text-capitalize" style={{ width: 50, textAlign: data === 'Exhibitor' ? 'left' : 'center', whiteSpace: 'normal', minWidth: 120 }}>
                                                    {data}
                                                </th>
                                            ))
                                        }

                                    </tr>
                                </thead><tbody>
                                    {
                                        currentRecords.length > 0 ?
                                            currentRecords.map((data, index) => (
                                                <tr key={index}>
                                                    {
                                                        data.map((item, i) => (
                                                            i != 1 && (
                                                                <td
                                                                    key={i}
                                                                    className={headerData[i] != 'SR No' && headerData[i] != 'Exhibitor' && headerData[i] != 'Type' && headerData[i] != 'PaymentDetails' ? "text-center text-aqua" : (headerData[i] === 'Exhibitor' ? "" : "text-center")}
                                                                    style={{ cursor: "pointer", textAlign: headerData[i] === 'Exhibitor' ? 'left' : 'center' }}
                                                                    onClick={() => headerData[i] != 'SR No' && headerData[i] != 'Exhibitor' && headerData[i] != 'Type' && headerData[i] != 'PaymentDetails' &&
                                                                        this.handleManualFormModal(
                                                                            headerData[i],
                                                                            data[1]
                                                                        )
                                                                    }
                                                                >
                                                                    {item}
                                                                </td>
                                                            )
                                                        ))
                                                    }
                                                </tr>
                                            ))
                                            :
                                            <tr>
                                                <td colSpan={13} style={{ textAlign: 'center' }}>
                                                    Record not found
                                                </td>
                                            </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="row m-0 px-2 mt-2 mx-1 align-items-center justify-content-between">
                        <div className="col-auto p-0">
                            {
                                exhibitorList.length > 0 &&
                                <Pagination
                                    nPages={nPages}
                                    currentPage={currentPage}
                                    setCurrentPage={this.updateItem}
                                />
                            }
                        </div>
                        <div className="col-auto p-0" style={{ textAlign: 'right' }}>
                            <p className="mb-0">{`${currentPage} of ${nPages} pages`}</p>
                        </div>
                    </div>
                </div>

                {/* <Footerwithdr /> */}
                <Modal
                    isOpen={this.state.isManualFormModalOpen}
                    onRequestClose={() => this.setState({ isManualFormModalOpen: false })}
                    shouldCloseOnEsc={true}
                    shouldCloseOnOverlayClick={true}
                    ariaHideApp={false}
                >
                    <div className="modal-dialog modal-almost-fullscreen">
                        <div className="modal-content">
                            <div className="modal-header p-2">
                                <h6 className="modal-title">Manual Form</h6>
                                {/* <button
                                    type="button"
                                    className="btn-close btn-close-white"
                                    onClick={() => this.setState({ isManualFormModalOpen: false })}
                                  /> */}
                            </div>

                            <div className="modal-body p-2">{this.openModal(this.state.selectedServiceName)}</div>


                            <div className="modal-footer py-1">
                                <button
                                    className="btn btn-gray"
                                    onClick={() => this.setState({ isManualFormModalOpen: false })}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
            </>
        )
    }
}
export default withRouter(connect(null, {
    fill_action, getExhibitorManualFormSummaryList_action, getExhibitorManualFormSummaryExport_action
})(ManualFormSummary))